import styled from "@emotion/styled";

const ColoredPageContainer = styled("div")(({ theme }) => ({
  minHeight: "100%",
  width: "100%",
  backgroundColor: theme.palette.primary.main,
}));

export default ColoredPageContainer;
